import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import BookSection from './components/BookSection';
import OtherBooksSection from './components/OtherBooksSection';
import ExcerptSection from './components/ExcerptSection';
import ReviewsSection from './components/ReviewsSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://example.com';

    const schemas = [
      {
        id: 'schema-website',
        data: {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Kevin Hamlett — Author',
          url: siteUrl,
          description: 'Official website of Kevin Hamlett, author of A River PENETRATING THE Soul Line: Book #II.',
          author: {
            '@type': 'Person',
            name: 'Kevin Hamlett',
          },
        },
      },
      {
        id: 'schema-webpage',
        data: {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Kevin Hamlett — Author of A River PENETRATING THE Soul Line',
          url: siteUrl,
          description: 'Official website of Kevin Hamlett, author of A River PENETRATING THE Soul Line: Book #II. A lyrical spiritual journey through consciousness, nature, and the soul.',
          inLanguage: 'en-US',
          isPartOf: { '@type': 'WebSite', url: siteUrl },
          dateModified: '2026-04-14',
        },
      },
      {
        id: 'schema-person',
        data: {
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: 'Kevin Hamlett',
          url: siteUrl,
          description: 'Kevin Hamlett is a writer, thinker, and spiritual explorer whose work invites readers to look inward — to examine the currents of thought and feeling that shape who we are.',
          jobTitle: 'Author',
          sameAs: [
            'https://www.amazon.com/s?k=Kevin+Hamlett&s=digital-text',
          ],
          worksFor: {
            '@type': 'Organization',
            name: 'Leavitt Peak Press',
          },
        },
      },
      {
        id: 'schema-book',
        data: {
          '@context': 'https://schema.org',
          '@type': 'Book',
          name: 'A River PENETRATING THE Soul Line',
          alternateName: 'A River Penetrating The Soul Line: Book #II',
          url: 'https://www.amazon.com/dp/B0GT29CWSG',
          author: {
            '@type': 'Person',
            name: 'Kevin Hamlett',
          },
          publisher: {
            '@type': 'Organization',
            name: 'Leavitt Peak Press',
          },
          datePublished: '2026-03-18',
          inLanguage: 'en',
          isbn: '978-1969865374',
          numberOfPages: 76,
          bookFormat: 'EBook',
          genre: ['Spirituality', 'Self-Help', 'Poetry'],
          description: 'A river twists, whirls, and bursts across the shore — lavish, unstoppable, alive. In the calm of daylight, it pours again and again, a cascade that mirrors the currents of our own minds. Each drop awakens thought, stirs the heart, and calls us to dive in.',
          offers: {
            '@type': 'Offer',
            price: '3.99',
            priceCurrency: 'USD',
            availability: 'https://schema.org/InStock',
            url: 'https://www.amazon.com/dp/B0GT29CWSG',
            seller: {
              '@type': 'Organization',
              name: 'Amazon',
            },
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '5.0',
            bestRating: '5',
            worstRating: '1',
            ratingCount: '6',
          },
        },
      },
      {
        id: 'schema-book-endless-hope',
        data: {
          '@context': 'https://schema.org',
          '@type': 'Book',
          name: 'Endless Hope: A Look at Glaring Reality',
          url: 'https://www.amazon.com/dp/B0FQRNYL93',
          author: {
            '@type': 'Person',
            name: 'Kevin Edward Hamlett',
          },
          publisher: {
            '@type': 'Organization',
            name: 'Leavitt Peak Press',
          },
          datePublished: '2025-09-10',
          inLanguage: 'en',
          isbn: '978-1969870628',
          numberOfPages: 63,
          bookFormat: 'EBook',
          genre: ['Spirituality', 'Poetry', 'Self-Help', 'Faith'],
          description: 'Endless Hope shines a light on the universal struggles we all face at one point or another. At its core, humanity shares a timeless pursuit for unshakeable faith, enduring hope, and unconditional love.',
          offers: {
            '@type': 'Offer',
            price: '3.38',
            priceCurrency: 'USD',
            availability: 'https://schema.org/InStock',
            url: 'https://www.amazon.com/dp/B0FQRNYL93',
            seller: {
              '@type': 'Organization',
              name: 'Amazon',
            },
          },
        },
      },
    ];

    const injected: HTMLScriptElement[] = [];

    schemas.forEach(({ id, data }) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
      injected.push(script);
    });

    return () => {
      injected.forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen font-sans bg-stone-950">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <BookSection />
        <OtherBooksSection />
        <ExcerptSection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
